import { NgClass } from '@angular/common'
import { Component, inject, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'

import { SkeletonModule } from 'primeng/skeleton'
import { finalize } from 'rxjs'

import { ButtonComponent } from 'app/_shared/components/button/button.component'
import { Product } from 'app/_shared/interfaces/Product'
import { ProductService } from 'app/_shared/services/product.service'
import { AppConfigService } from 'app/app-config.service'

import { ProductItemComponent } from '../product-item/product-item.component'

@Component({
  selector: 'app-not-found',
  imports: [ButtonComponent, SkeletonModule, ProductItemComponent, NgClass],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent implements OnInit {
  private appConfigService = inject(AppConfigService)
  private productService = inject(ProductService)
  private route = inject(ActivatedRoute)
  storefrontId: number
  productErrorMode: boolean
  isLoading = false
  products: Product[] = []
  skeletons: number[] = Array(6)

  paginatorOptions = {
    total: 0,
    rows: 3,
    first: 0,
    last_page: 0
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.productErrorMode = params['product']
    })
    this.storefrontId = this.appConfigService.getAppConfig?.id
    if (this.productErrorMode) {
      this.fetchStorefrontProducts()
    }
  }

  fetchStorefrontProducts() {
    this.isLoading = true

    const pageNumber = Math.floor(this.paginatorOptions.first / this.paginatorOptions.rows) + 1

    const query = {
      rows: this.paginatorOptions.rows,
      page: pageNumber
    }

    this.productService
      .getProducts(this.storefrontId, query)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: response => {
          this.products = response.data.data
          this.paginatorOptions.total = response.data.total
          this.paginatorOptions.last_page = response.data.last_page
        },
        error: err => {
          console.error(err)
        }
      })
  }
}
